import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import GlobalSearch from "./GlobalSearch";
import { useFavorites } from "@/hooks/useFavorites";

const navItems = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category", label: "电影", icon: "ri-film-line", end: false },
  { to: "/news", label: "资讯", icon: "ri-newspaper-line", end: false },
  { to: "/reviews", label: "影评", icon: "ri-chat-quote-line", end: false },
  { to: "/about", label: "关于", icon: "ri-information-line", end: false },
];

function MinionLogo() {
  return (
    <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500">
      <span className="absolute left-1/2 top-1/2 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-[3px] border-foreground-900 bg-background-50">
        <span className="h-1.5 w-1.5 rounded-full bg-foreground-900"></span>
      </span>
      <span className="absolute bottom-1.5 left-1/2 h-[3px] w-3 -translate-x-1/2 rounded-full bg-foreground-900/70"></span>
    </span>
  );
}

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { items } = useFavorites();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "border-background-200 bg-background-50/90 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <MinionLogo />
          <span className="font-heading text-lg font-bold leading-none text-foreground-950">
            小黄人<span className="text-primary-600">电影</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium transition ${
                  isActive
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden w-60 lg:block">
            <GlobalSearch />
          </div>
          <Link
            to="/category"
            aria-label="我的收藏"
            className="relative flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
          >
            <i className="ri-heart-line text-lg"></i>
            {items.length > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-secondary-500 px-1 text-[10px] font-bold text-background-50">
                {items.length}
              </span>
            )}
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <GlobalSearch placeholder="搜索电影、资讯或影评…" />
          <nav className="mt-3 grid gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                <i className={`${item.icon} text-lg`}></i>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}